import { useQuery } from "@tanstack/react-query";

import type { components } from "@/api/types";
import { apiGet, qk } from "@/shared/api";

type ChartPeriod = components["schemas"]["ChartPeriod"];

/** См. `entities/home` — тот же интервал и та же причина держать его точечно. */
const REFETCH_MS = 5 * 60_000;

/**
 * Купленные роботы. Список приходит целиком — ни курсора, ни фильтров в
 * контракте нет: у одного пользователя их единицы.
 */
export function useMyRobots() {
  return useQuery({
    queryKey: qk.myRobots(),
    queryFn: ({ signal }) => apiGet("/api/v1/my-robots", { signal }),
  });
}

/**
 * Деталь: карточка + график за выбранный период + вся история по дням.
 *
 * `id` здесь — идентификатор ПОКУПКИ (`user_robot`), а не робота из каталога.
 * Чужая покупка приходит как 404, а не 403.
 *
 * `daily_results` от периода не зависит — это суточные итоги за всю историю;
 * период меняет только `chart`.
 */
export function useMyRobot(id: number, period: ChartPeriod, enabled = true) {
  return useQuery({
    // `enabled` нужен экрану робота: переключатель «Стратегия / Мой результат»
    // рисуется только у владельца, но хук обязан вызываться безусловно —
    // порядок хуков не может зависеть от наличия покупки.
    enabled: enabled && Number.isFinite(id),
    queryKey: qk.myRobot(id, period),
    queryFn: ({ signal }) =>
      apiGet("/api/v1/my-robots/{user_robot_id}", {
        params: { user_robot_id: id },
        query: { period },
        signal,
      }),
    refetchInterval: REFETCH_MS,
    placeholderData: (previous) => previous,
  });
}
